<div class="site-page-header-ghost-wrapper">
  <nz-page-header [nzGhost]="false" nzBackIcon>
    <nz-page-header-title class="ml4"
      >Answer Sheet Details</nz-page-header-title
    >
    <nz-page-header-subtitle *ngIf="answerSheet">
      {{ answerSheet.user?.name || answerSheet.user }} •
      {{ answerSheet.test?.name || answerSheet.test }}
    </nz-page-header-subtitle>
  </nz-page-header>
</div>

<div *ngIf="loading && !answerSheet" class="loader text-center">
  <nz-spin nzTip="Loading..."></nz-spin>
</div>

<div *ngIf="answerSheet" class="mt4">
  <!-- ✅ STATS ROW -->
  <nz-row nzGutter="16">
    <nz-col nzSpan="3">
      <nz-card class="stat-card total">
        <h4>Total Questions</h4>
        <div class="stat">{{ totalQuestions || 0 }}</div>
      </nz-card>
    </nz-col>

    <nz-col nzSpan="3">
      <nz-card class="stat-card correct">
        <h4>Correct</h4>
        <div class="stat">{{ correctCount || 0 }}</div>
      </nz-card>
    </nz-col>

    <nz-col nzSpan="3">
      <nz-card class="stat-card incorrect">
        <h4>Incorrect</h4>
        <!-- ✅ Only answered-wrong questions, NOT unanswered -->
        <div class="stat">{{ incorrectCount || 0 }}</div>
      </nz-card>
    </nz-col>

    <!-- ✅ NEW Not Visited card -->
    <nz-col nzSpan="3">
      <nz-card class="stat-card unseen">
        <h4>Not Visited</h4>
        <div class="stat">{{ unseenCount || 0 }}</div>
      </nz-card>
    </nz-col>

    <nz-col nzSpan="3">
      <nz-card class="stat-card review">
        <h4>Review</h4>
        <div class="stat">{{ markedForReviewCount || 0 }}</div>
      </nz-card>
    </nz-col>

    <nz-col nzSpan="3">
      <nz-card class="stat-card info">
        <h4>Total Time</h4>
        <div class="stat">{{ formatTime(answerSheet.time) }}</div>
      </nz-card>
    </nz-col>

    <nz-col nzSpan="3">
      <nz-card class="stat-card info">
        <h4>Completed Time</h4>
        <div class="stat">{{ formatTime(answerSheet.completedTime) }}</div>
      </nz-card>
    </nz-col>

    <nz-col nzSpan="3">
      <nz-card class="stat-card score">
        <h4>Score</h4>
        <div class="stat">
          {{ totalMarksObtained || 0 }} /
          {{ totalMarksPossible.toFixed(2) || 0 }}
        </div>
      </nz-card>
    </nz-col>
  </nz-row>

  <!-- MAIN CARD -->
  <nz-card class="mt4 main-card">
    <div nz-row [nzGutter]="[16, 16]">
      <!-- TAGS -->
      <div nz-col nzSpan="24" class="mt4 tag-row">
        <nz-tag nzColor="blue">{{ answerSheet?.user?.name }}</nz-tag>
        <nz-tag nzColor="purple">{{ answerSheet?.examType }}</nz-tag>
        <nz-tag nzColor="gold"
          >Total Time - {{ formatTime(answerSheet?.time) }}</nz-tag
        >
        <nz-tag nzColor="green">
          Score - {{ totalMarksObtained }}/{{ totalMarksPossible.toFixed(2) }}
        </nz-tag>
      </div>

      <!-- SECTIONS -->
      <nz-collapse nzAccordion *ngIf="answerSheet?.section" class="mt4">
        <nz-collapse-panel
          *ngFor="let sec of answerSheet.section; index as i"
          [nzHeader]="sec.sectionName || 'Section ' + (i + 1)"
          [nzActive]="false"
          [nzExtra]="extraTpl"
        >
          <!-- LOADER PER SECTION -->
          <ng-container *ngIf="sectionLoadingMap[i]; else sectionContent">
            <div class="panel-loader text-center">
              <nz-spin nzTip="Loading section..."></nz-spin>
              <nz-skeleton
                [nzActive]="true"
                [nzParagraph]="{ rows: 4 }"
                [nzTitle]="true"
              ></nz-skeleton>
            </div>
          </ng-container>

          <!-- ACTUAL CONTENT -->
          <ng-template #sectionContent>
            <!-- SECTION SUMMARY -->
            <div class="section-summary">
              <nz-tag nzColor="blue"
                >Q: {{ sec.questions?.length || 0 }}</nz-tag
              >
              <nz-tag nzColor="gold">Time: {{ formatTime(sec.time) }}</nz-tag>
              <nz-tag nzColor="green"
                >Completed: {{ formatTime(sec.completedTime) }}</nz-tag
              >
            </div>

            <!-- QUESTIONS -->
            <div
              class="question-card"
              *ngFor="let q of sec.questions; index as idx"
            >
              <div class="question-title">
                Q{{ idx + 1 }}.
                <app-mathjax [content]="q.questionText"></app-mathjax>
              </div>

              <div class="options">
                <div *ngFor="let opt of q.options">
                  <nz-tag
                    [nzColor]="
                      opt.isCorrectOption
                        ? 'green'
                        : q.answerText === opt.optionText
                          ? 'red'
                          : 'default'
                    "
                  >
                    <app-mathjax [content]="opt.optionText"></app-mathjax>
                  </nz-tag>
                </div>
              </div>

              <div class="answer-row">
                <span>
                  <strong>Answer Given:</strong>
                  <!-- ✅ Show 'Not Visited' if no answer was given -->
                  <ng-container *ngIf="q.answerText; else notVisitedAnswer">
                    <nz-tag [nzColor]="q.isCorrect ? 'green' : 'red'">
                      <app-mathjax [content]="q.answerText"></app-mathjax>
                    </nz-tag>
                  </ng-container>
                  <ng-template #notVisitedAnswer>
                    <nz-tag nzColor="default">Not Visited</nz-tag>
                  </ng-template>
                </span>

                <span>
                  <strong>Correct:</strong>
                  <!-- ✅ Show 'Not Visited' if unanswered, else Yes/No -->
                  <nz-tag
                    [nzColor]="
                      !q.answerText ? 'default' : q.isCorrect ? 'green' : 'red'
                    "
                  >
                    {{
                      !q.answerText ? "Not Visited" : q.isCorrect ? "Yes" : "No"
                    }}
                  </nz-tag>
                </span>

                <span><strong>Marks:</strong> {{ q.marks || 0 }}</span>
                <span
                  ><strong>Negative:</strong> {{ q.negativeMarks || 0 }}</span
                >
                <span
                  ><strong>Obtained:</strong> {{ q.marksObtained || 0 }}</span
                >
              </div>
            </div>
          </ng-template>

          <!-- EXTRA -->
          <ng-template #extraTpl>
            <nz-tag nzColor="magenta"
              >Total Q - {{ sec.questions?.length }}</nz-tag
            >
            <nz-tag nzColor="gold" *ngIf="sec.time"
              >Time - {{ formatTime(sec.time) }}</nz-tag
            >
          </ng-template>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </nz-card>
</div>
